import React, { useEffect, useState, useMemo } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import '../../fonts/fonts.css'
import SideBar from '../SideBar'
import { connect, useSelector, useDispatch } from 'react-redux'
import { compose } from 'redux'
import injectSaga from '../../utils/injectSaga'
import { simuPlayerTrainingsData, deleteSimuPlayerSaga } from './saga'
import { simuPlayerTrainings, deleteSimuPlayer, hideModal, patchSessionSuccess } from '../App/actions'
import PageHeader from '../../components/PageHeader'
import graduationIcon from '../../images/icon-graduation.png'
import ModalConfirm from '../../components/ModalConfirm'
import {
  DashboardContainer, ButtonContainer, Success, ImgSuccess, TextSuccess,
  Bg, MainLayout, MainContainer, FormContainer, BoxContainer, Name,
  SelectorLicenceContainer, LicenceSelector,
  TrainingChoices, TrainingInput, TrainingLabel,
  DeleteButton, Button, ErrorContainer, FeedBack,
  SessionsWrapper, SessionsSectionTitle, SessionsList, SessionCard, SessionLogo,
  SessionInfoBlock, SessionCategory, SessionName, SessionMeta, SessionMetaLine,
  SessionSpacer, StatusTag, RetireBtn, SessionEmptyRow,
} from './styledComponents'
import Dashboard from '../../components/Dashboard'
import InfoContainer from '../../components/SimuPlayer_InfoContainer'

import CheckboxOff from '../../images/checkboxOff.svg'
import CheckboxOn from '../../images/checkboxOn.svg'

import logoTgdEval       from '../../images/logo-tgd-eval.png'
import logoTgdMeteo      from '../../images/logo-tgd-meteo.png'
import logoTgdDeclivite from '../../images/logo-tgd-declivite.png'
import logoTgdRemc       from '../../images/logo-tgd-remc.png'
import logoTgdEco        from '../../images/logo-tgd-eco.png'
import logoTgdPasserelle from '../../images/logo-tgd-passerelle.png'
import logoTgdPostPermis from '../../images/logo-tgd-post-permis.png'

import "./styles.css"

const apiBase = process.env.REACT_APP_TGDAPI_SERVER || ''
const editorPath = process.env.REACT_APP_SERVER_API
const whatApiToken = process.env.REACT_APP_WHATAPI_TOKEN

const getSessionMeta = ({ category, title }) => {
  const t = (title || '').toLowerCase()
  if (category === 'Eval')     return { color: '#6462FC', label: 'ÉVALUATION ET BILAN', logo: logoTgdEval }
  if (category === 'Hardware') return { color: '#00C8F8', label: 'MATÉRIEL',             logo: logoTgdRemc }
  if (category === 'Conduite') {
    if (t.includes('météo') || t.includes('meteo'))                    return { color: '#3494FA', label: 'MÉTÉO',        logo: logoTgdMeteo }
    if (t.includes('déclivité') || t.includes('declivite'))            return { color: '#3494FA', label: 'DÉCLIVITÉ',    logo: logoTgdDeclivite }
    if (t.includes('éco') || t.includes('eco'))                       return { color: '#3494FA', label: 'ÉCO-CONDUITE', logo: logoTgdEco }
    if (t.includes('post permis') || t.includes('post-permis'))       return { color: '#3494FA', label: 'POST PERMIS',  logo: logoTgdPostPermis }
    if (t.includes('passerelle'))                                      return { color: '#3494FA', label: 'PASSERELLE',   logo: logoTgdPasserelle }
    return { color: '#3494FA', label: 'CONDUITE', logo: logoTgdRemc }
  }
  return { color: '#6462FC', label: (category || 'FORMATION').toUpperCase(), logo: logoTgdRemc }
}

const STATUS_LABEL = { pending: 'En attente', started: 'En cours', completed: 'Terminée' }
const formatDate   = d => d ? new Date(d).toLocaleDateString('fr-FR') : '—'

const SimuPlayerTrainings = (props) => {
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()

  const players = useSelector((state) => state.toJS().global.simuPlayers)
  const error = useSelector((state) => state.toJS().global.error)
  const loading = useSelector((state) => state.toJS().global.loading)
  const token = useSelector((state) => state.toJS().global.agencytoken)
  const successStore = useSelector((state) => state.toJS().global.success)
  const trainings =  useSelector((state) => state.toJS().global.trainings)
  const agencyTrainings = useSelector((state) => state.toJS().global.agencyTrainings)
  const agencyTrainingIds = useSelector((state) => state.toJS().global.agencyTrainingIds)
  const isAdmin        = useSelector((state) => state.toJS().global.isAdmin)
  const adminSessions  = useSelector((state) => state.toJS().global.sessions)
  const adminOrdersRaw = useSelector((state) => state.toJS().global.orders)
  const adminLoading   = loading

  const id = location.query ? location.query.id : location.pathname.split('/')[3]
  const player = players ? players.find(player => player.id === id || player._id === id) : ''

  const [success, setSuccess] = useState()
  const [playerSessions, setPlayerSessions] = useState([])
  const [sessionOrdersMap, setSessionOrdersMap] = useState({})
  console.log('success', success)
  const [playerId, setPlayerId] = useState(id)
  const [playerAgency, setPlayerAgency] = useState(player.agencyId)
  const [playerTrainings, setPlayerTrainings] = useState([...(player.availableTrainings || [])])
  const [modalName, setModalName] = useState()
  const [modalText, setModalText] = useState()
  const [warn, setWarn] = useState({ lastname: false, firstname: false, mail: false, psw: false, repPsw: false, error: false })
  const [showModal, setShowModal] = useState(false)
  const [errorCode, setErrorCode] = useState(0)
  const [playerLicence, setPlayerLicence] = useState(player.trainingType || '')
  const [availableTrainings, setAvailableTrainings] = useState([])
  const [trainingsCatalog, setTrainingsCatalog] = useState([])

  const workshopTitles = ['EVAL', 'REMC']
  const hasTrainingAccess = () => (
    (Array.isArray(agencyTrainings) && agencyTrainings.length > 0) ||
    (Array.isArray(agencyTrainingIds) && agencyTrainingIds.length > 0)
  )

  useEffect(() => {
    fetch(`${editorPath}/api/trainings?access_token=${whatApiToken}`)
      .then(r => r.json())
      .then(data => { if (Array.isArray(data)) setTrainingsCatalog(data) })
      .catch(() => {})
  }, [])
  
  useEffect(() => {
    if (!id || !token) return
    
    // Fetch sessions and orders for this specific student
    const fetchPlayerSessions = async () => {
      try {
        // Fetch sessions
        const response = await fetch(`${apiBase}/sessions?studentId=${id}`, {
          method: 'GET',
          headers: { 'Authorization': `Bearer ${token}` }
        })
        if (response.ok) {
          const data = await response.json()
          const sessions = Array.isArray(data) ? data : (data.data || [])
          console.log('Fetched sessions:', sessions)
          setPlayerSessions(sessions)
        }
        
        // Fetch orders to map with sessions
        const ordersResponse = await fetch(`${apiBase}/order`, {
          method: 'GET',
          headers: { 'Authorization': `Bearer ${token}` }
        })
        if (ordersResponse.ok) {
          const ordersData = await ordersResponse.json()
          const orders = Array.isArray(ordersData) ? ordersData : (ordersData.orders || [])
          const ordersMap = {}
          orders.forEach(o => { ordersMap[o._id] = o })
          console.log('Fetched orders map:', ordersMap)
          setSessionOrdersMap(ordersMap)
        }
      } catch (err) {
        console.error('Error fetching player sessions or orders:', err)
      }
    }
    
    fetchPlayerSessions()
  }, [id, token])
  
  useEffect(() => {
    displayModal(successStore)
    errorCheck(error)
    if (hasTrainingAccess()) {
      setAvailableTrainings([
        ...getTrainingTitles(true),
        ...getTrainingTitles(false)
      ])
    }
    // eslint-disable-next-line
  }, [player._id, loading, successStore, error])

  const orderMap = useMemo(() => {
    return sessionOrdersMap
  }, [sessionOrdersMap])

  const adminOrders = useMemo(() => {
    if (!adminOrdersRaw) return {}
    const map = {}
    adminOrdersRaw.forEach(o => { if (o._id) map[o._id] = o })
    return map
  }, [adminOrdersRaw])

  const effectiveSessions = !isAdmin && adminSessions && adminSessions.length > 0
    ? (adminSessions || []).filter(s => s.studentId === id)
    : playerSessions

  const effectiveOrderMap = !isAdmin && adminOrders ? adminOrders : orderMap

  const retireSession = async (sessionId) => {
    const isUsingAdminSessions = !isAdmin && adminSessions && adminSessions.length > 0
    const sessions = isUsingAdminSessions ? adminSessions : playerSessions
    const session = sessions.find(s => s._id === sessionId)
    if (!session) return
    
    try {
      const resp = await fetch(`${apiBase}/sessions/${sessionId}`, {
        method:  'PATCH',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body:    JSON.stringify({ studentId: null }),
      })
      if (resp.ok) {
        const updatedSession = { ...session, studentId: null }
        setPlayerSessions(prev => prev.map(s => s._id === sessionId ? updatedSession : s))
        dispatch(patchSessionSuccess(updatedSession))
      }
    } catch (err) {
      console.error('Error retiring session:', err)
    }
  }

  const errorCheck = (err) => {
    if (err) {
      switch (error) {
        case "Failed to fetch":
          setSuccess(false); setWarn({ error: true }); setModalText('Impossible d\'accéder au serveur'); setErrorCode(error)
          break
        default:
          setSuccess(false); setWarn({ error: true }); setModalText('Erreur'); setErrorCode(error)
      }
    }
  }

  const displayModal = (show) => {
    if(show){
      setSuccess(true)
      setTimeout(() => {
        dispatch(hideModal())
        setSuccess(false)
      }, 2000);
    }
  }


  const handleClick = () => {
    dispatch(simuPlayerTrainings({ id, token: token, trainingType: playerLicence, trainings: playerTrainings,availableTrainings: playerTrainings }))
  }

  function handleChangeLicence (e) {
    setPlayerLicence(e.value)
  }

  const licences = [
    {value: 'B', label: 'B'},
    {value: 'BEA', label: 'BEA'},
    {value: 'AAC', label: 'AAC'},
    {value: 'BEA AAC', label: 'BEA AAC'}
  ]

  const DisplayLicenceSelector = () => {
    let currentLicenceIndex = licences.indexOf(licences.find((li) => li.value === player.trainingType))

      return (
        <LicenceSelector
          classNamePrefix='react-select'
          multiple={false}
          isSearchable={false}
          defaultValue={licences[currentLicenceIndex]}
          onChange={(e) => {handleChangeLicence(e)}}
          options={licences}>
        </LicenceSelector>
      )
  }


  const Checkbox = ({ name, boxChecked, onChange }) => {
    return (
      <TrainingLabel className='trainingChoice'>
          <TrainingInput type="checkbox" id={name} value={name} checked={boxChecked} onChange={onChange} />
          <img className="checkbox-img-checked" alt="check" src={CheckboxOn} width="16px" height="14px"></img>
          <img className="checkbox-img-unchecked" alt="uncheck" src={CheckboxOff} width="16px" height="14px"></img>
          <TrainingLabel htmlFor={name}>{name}</TrainingLabel>
      </TrainingLabel>
    );
  };

  const getLegacyTrainingTitles = (isWorkshop) => {
    if (!agencyTrainings) return []
    if (typeof agencyTrainings[0] === 'string') {
      return agencyTrainings.filter(t => isWorkshop ? workshopTitles.includes(t) : !workshopTitles.includes(t))
    }
    return agencyTrainings.filter(t => isWorkshop ? t.isWorkshop : !t.isWorkshop).flatMap(t => t.title)
  }

  const getTrainingTitles = (isWorkshop) => {
    const titles = new Set(getLegacyTrainingTitles(isWorkshop))
    if (Array.isArray(agencyTrainingIds) && agencyTrainingIds.length > 0) {
      const allowedIds = new Set(agencyTrainingIds.map(String))
      trainingsCatalog
        .filter(t => allowedIds.has(String(t.id)) && Boolean(t.isWorkshop) === isWorkshop)
        .forEach(t => titles.add(t.title))
    }
    return Array.from(titles)
  }

  const displayTrainingsChoices = () => {
    if (hasTrainingAccess()) {
      return (
        <TrainingChoices>
          {getTrainingTitles(true).map((title, index) => {
              return (
                <Checkbox
                  key={index}
                  name={title}
                  boxChecked={playerTrainings.includes(title)}
                  onChange={() => handleTrainingClick(title)}
                />
              )
            })}
        </TrainingChoices>
      );
    } else {
      return <TrainingChoices></TrainingChoices>
    }
  }

  const displayTrainingsChoices2 = () => {
    if (hasTrainingAccess()) {
      return (
        <TrainingChoices>
          {getTrainingTitles(false).map((title, index) => {
              return (
                <Checkbox
                  key={index}
                  name={title}
                  boxChecked={playerTrainings.includes(title)}
                  onChange={() => handleTrainingClick(title)}
                />
              )
            })}
        </TrainingChoices>
      );
    } else {
      return <TrainingChoices></TrainingChoices>
    }
  }

  const handleTrainingClick = (trainingTitle) => {
    setPlayerTrainings(prevTrainings => {
      if (prevTrainings.includes(trainingTitle)) {
        return prevTrainings.filter(t => t !== trainingTitle);
      } else {
        return [...prevTrainings, trainingTitle];
      }
    });
  };

  function renderSuccess () {
    return (
      <Success>
        <ImgSuccess />
        <TextSuccess>L'élève à bien été modifié !</TextSuccess>
      </Success>
    )
  }

  function confirmDelete (id, action, firstname) {
    setShowModal(true)
    setPlayerId(id)
    setModalText(`${action}`)
    setModalName(`${firstname}`)
  }

  const deletePlayer = (id) => { // FIXME: set timeout ???
    dispatch(deleteSimuPlayer(token, id, playerAgency))
    setTimeout(() => {
      history.push('/simuplayers')
    }, 100)
  }


  if (!player.firstname) {
    return <div>LOADING</div>
  }

  return (
    <Bg>
      <SideBar />
      <MainLayout>
        {success
          ? renderSuccess()
          : <div />}
        <PageHeader
          icon={graduationIcon}
          title='Formations'
          subtitle={player.firstname ? `${player.firstname} ${player.lastname}` : 'Attribuer des formations'}
        />
        <MainContainer>
        <ModalConfirm
          show={showModal}
          confirmText='Supprimer'
          text={modalText}
          name={modalName}
          confirm={() => deletePlayer(playerId)}
          cancel={() => setShowModal(false)}
        />

        <DashboardContainer>
          <Dashboard height={'48px'} type='edit' data={{firstName: player.firstname, lastName: player.lastname}}/>
        </DashboardContainer>
        <InfoContainer path={location.pathname} playerId={playerId} />
        <FormContainer>
          <div />
          {/*<BoxContainer>
            <Name>Formations général</Name>
            {displayTrainingsChoices()}
          </BoxContainer>
          <BoxContainer style={{marginTop:'1rem'}}>
            <Name>Formations personnalisées</Name>
            {displayTrainingsChoices2()}
          </BoxContainer>
          */}

          <SessionsWrapper>
            <Name style={{ marginBottom: '0.5rem' }}>Formations attribuées</Name>
            <SessionsList>
              {isAdmin && adminLoading ? (
                <SessionEmptyRow>Chargement des formations…</SessionEmptyRow>
              ) : effectiveSessions.length === 0 ? (
                !isAdmin && (
                  <SessionEmptyRow onClick={() => history.push('/sessions')}>
                    Aucune formation attribuée à cet élève. Cliquez ici pour attribuer une formation.
                  </SessionEmptyRow>
                )
              ) : (
                effectiveSessions.map(session => {
                  console.log('Session:', session)
                  console.log('OrderMap:', orderMap)
                  const order  = orderMap[session.orderId]
                  console.log('Order for orderId', session.orderId, ':', order)
                  const item   = order?.items?.[session.orderItemIndex]
                  console.log('Item at index', session.orderItemIndex, ':', item)
                  const name   = item?.name || session.title || 'Formation inconnue'
                  const cat    = item?.category || 'Conduite'
                  const { color, label, logo } = getSessionMeta({ category: cat, title: name })
                  return (
                    <SessionCard key={session._id}>
                      <SessionLogo><img src={logo} alt='' /></SessionLogo>
                      <SessionInfoBlock>
                        {/* <SessionCategory color={color}>{label}</SessionCategory> */}
                        <SessionName>{name}</SessionName>
                      </SessionInfoBlock>
                      <SessionMeta>
                        <SessionMetaLine>Début : {formatDate(session.startedAt)}</SessionMetaLine>
                        <SessionMetaLine>Fin : {formatDate(session.endingAt)}</SessionMetaLine>
                      </SessionMeta>
                      <SessionSpacer />
                      <StatusTag status={session.status}>
                        {STATUS_LABEL[session.status] || session.status}
                      </StatusTag>
                      {session.status === 'pending' && (
                        <RetireBtn onClick={() => retireSession(session._id)}>Retirer</RetireBtn>
                      )}
                    </SessionCard>
                  )
                })
              )}
            </SessionsList>
          </SessionsWrapper>
        </FormContainer>
        <ErrorContainer>
          <FeedBack style={{ opacity: warn.error ? '1' : '0' }}>{modalText}</FeedBack>
        </ErrorContainer>
        </MainContainer>
      </MainLayout>
    </Bg>
  )
}

const withConnect = connect(null, null)
const withSaga = injectSaga({ key: 'simuPlayerTrainings', saga: simuPlayerTrainingsData })
const withDeleteSaga = injectSaga({ key: 'deleteSimuPlayer', saga: deleteSimuPlayerSaga })

const arg = compose(withSaga, withDeleteSaga, withConnect)(SimuPlayerTrainings)

export default arg
